
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1126"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1126"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("bm3Mu", function(module, exports) {

$parcel$export(module.exports, "initializeDropdown", () => $8444ae9fc2b3a4e1$export$cd2c06ce74bff7fa);
$parcel$export(module.exports, "convertSelectsToCustomDropdowns", () => $8444ae9fc2b3a4e1$export$38aeac4f7f3af7e9);
function $8444ae9fc2b3a4e1$export$cd2c06ce74bff7fa(dropdownElement) {
    if (dropdownElement.dataset.initialized === "true") return;
    dropdownElement.dataset.initialized = "true";
    const selectedTextElement = dropdownElement.querySelector(".dropdown-select > span");
    const hiddenInput = document.getElementById(dropdownElement.dataset.input);
    const dropdownOptions = dropdownElement.querySelector(".dropdown-options");
    const selectTrigger = dropdownElement.querySelector(".dropdown-select");
    if (selectTrigger) selectTrigger.addEventListener("click", (e)=>{
        e.stopPropagation();
        document.querySelectorAll(".custom-dropdown.open").forEach((openDropdown)=>{
            if (openDropdown !== dropdownElement) openDropdown.classList.remove("open");
        });
        dropdownElement.classList.toggle("open");
    });
    if (dropdownOptions) dropdownOptions.addEventListener("click", (e)=>{
        const target = e.target;
        if (target && target.tagName === "A") {
            e.preventDefault();
            const value = target.dataset.value;
            const text = target.textContent;
            if (selectedTextElement) {
                selectedTextElement.textContent = text;
                const i18nKey = target.getAttribute("data-i18n");
                if (i18nKey) selectedTextElement.setAttribute("data-i18n", i18nKey);
                else selectedTextElement.removeAttribute("data-i18n");
            }
            if (hiddenInput) {
                hiddenInput.value = value;
                try {
                    const event = new Event("change");
                    hiddenInput.dispatchEvent(event);
                } catch  {
                // Silently ignore event dispatch errors
                }
            }
            dropdownElement.classList.remove("open");
            const changeEvent = new CustomEvent("dropdown-change", {
                detail: {
                    dropdownId: dropdownElement.id,
                    value: value,
                    text: text
                }
            });
            dropdownElement.dispatchEvent(changeEvent);
        }
    });
}
function $8444ae9fc2b3a4e1$export$38aeac4f7f3af7e9() {
    const selects = document.querySelectorAll("select.form-select-premium, select.premium-select, select.form-select, select.premium-select-custom");
    selects.forEach((select)=>{
        if (select.dataset.converted) return;
        const container = document.createElement("div");
        container.className = "custom-dropdown";
        if (select.id) container.id = select.id + "-dropdown";
        const selectedOption = select.options[select.selectedIndex];
        const selectedText = selectedOption ? selectedOption.textContent : "Select...";
        const i18nKey = selectedOption ? selectedOption.getAttribute("data-i18n") : "";
        container.innerHTML = `
        <div class="dropdown-select">
          <span ${i18nKey ? `data-i18n="${i18nKey}"` : ""}>${selectedText}</span>
          <span class="arrow">&#9662;</span>
        </div>
        <div class="dropdown-options">
          ${Array.from(select.options).map((opt)=>`
            <a href="#" data-value="${opt.value}" ${opt.getAttribute("data-i18n") ? `data-i18n="${opt.getAttribute("data-i18n")}"` : ""}>
              ${opt.textContent}
            </a>
          `).join("")}
        </div>
      `;
        // Hide original select but keep it for form submission and events
        select.style.display = "none";
        select.dataset.converted = "true";
        select.parentNode.insertBefore(container, select.nextSibling);
        // Initialize the new custom dropdown
        $8444ae9fc2b3a4e1$export$cd2c06ce74bff7fa(container);
        // Listen for changes on the custom dropdown to sync back to select
        container.addEventListener("dropdown-change", (e)=>{
            select.value = e.detail.value;
            select.dispatchEvent(new Event("change", {
                bubbles: true
            }));
        });
    });
}

});


parcelRequire("bm3Mu");

//# sourceMappingURL=attendance_reports.61a110c7.js.map
